import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react';
import { DateTime } from 'luxon';
import { useLocation } from 'react-router-dom';
import { API, graphqlOperation } from 'aws-amplify';
import { snakeCase } from 'change-case';
import {
  Container,
  HeaderText,
  DataGrid,
  Button,
  StatusPill,
  PopUpConfirmation,
  DropDown,
  ToolTip,
} from '../../../components';
import { listOwnedCases } from '../../../generated/graphql/queries';
import { deleteCase } from '../../../generated/graphql/mutations';
import { NotificationContext } from '../../../helpers/AlertContext/AlertContext';
import { CaseStatus } from '../../../constants';
// import { useNotifications } from '../../../helpers/useNotifications';
// import { useNotifications } from '../../../contexts/notificationContext';
import { notificationGroups } from '../../../components/Notifications';
import { parseMarkdown } from '../../../helpers/markdown';
import NotificationToggle from '../../../components/NotificationToggle';
import { useNotifications } from '../../../contexts/notificationContext';
import { useUser } from '../../../contexts/userContext';
import { useHistory } from 'react-router-dom';

// const NotificationTypeOptions = (
//   filterFunc = groupsArray => {
//     return !groupsArray.isAdminOny;
//   }
// ) =>
//   [...notificationGroups].filter(filterFunc).map(group => ({
//     label: group.label,
//     value: group.types,
//   }));
const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

const getNotificationTime = dateString => {
  const luxonDate = DateTime.fromISO(dateString);

  // return luxonDate.toFormat('ff');
  return luxonDate.toFormat('DD');
};

const UserNotifications = ({ useVolunteerView = true }) => {
  const { isAdmin } = useUser();
  const history = useHistory();
  const {
    loading,
    notifications,
    fetchNotifications,
    fetchNewestNotifications,
    getIcon,
    markAsRead,
    markAsUnread,
    hasMore,
    notificationCount,
    resetNotifications,
  } = useNotifications();
  // const [gridNotifications, setGridNotifications] = useState([]);
  // const passedType = query.get('type')?.toUpperCase();
  // let initialFilterStatus = null;

  // if (Object.values(CaseStatus).indexOf(passedStatus) > -1) {
  //   initialFilterStatus = passedStatus;
  // }
  const [firstLoad, setFirstLoad] = useState(true);

  // const [, setAlert] = useContext(NotificationContext);
  const [userNotificationGroupOptions, setUserNotificationGroupOptions] = useState(() => {
    // Set the initial options based on the notification groups and user admin status
    const options = [...notificationGroups]
      .filter(group => {
        // If the user is an admin, show all groups
        if (group && group.adminOnly) {
          // Only show admin groups if the user is an admin or if we are using the volunteer view
          if (isAdmin) {
            if (useVolunteerView) {
              // If using volunteer view, don't show admin only groups
              return false;
            }
            return true;
          }
          return false;
        }
        return true;
      })
      .map(group => ({
        label: group.label,
        value: group.types,
      }));
    // console.log('Setting initial user notification group options:', options, { isAdmin, useVolunteerView });
    return options;
  });

  // const [nextCaseToken, setNextCaseToken] = useState();

  // const [cases, setCases] = useState([]);
  // const [casesLoading, setCasesLoading] = useState(true);

  const [type, setType] = useState(null);

  const [filters, setFilters] = useState({
    type: null,
    searchTerm: '',
  });

  const [sort, setSort] = useState({
    fieldName: 'createdAt',
    direction: 'DESC',
  });

  const [filtersOnLastSearch, setFiltersOnLastSearch] = useState(null);
  const [sortOnLastSearch, setSortOnLastSearch] = useState({
    fieldName: 'createdAt',
    direction: 'DESC',
  });

  const [search, setSearch] = useState('');

  // const [recordToDelete, setRecordToDelete] = useState(null);
  // const [deleting, setDeleting] = useState(false);

  useEffect(async () => {
    // fetchCases();
    resetNotifications();
    // setNextToken(null);
    // If no parameters are set, fetch the newest notifications
    if (firstLoad) {
      console.log('Fetching newest notifications');
      await fetchNewestNotifications();
      setFirstLoad(false);
      return;
    }
    // console.log('Fetching notifications with filters:', { type, sort, filters });
    fetchNotifications({ types: type, sort, filters }, null);
  }, [sort, filters, type]);

  // useEffect(() => {
  //   // Set the user notification groups based on the type filter
  //   const options = [...notificationGroups]
  //     .filter(group => {
  //       // If the user is an admin, show all groups
  //       if (group && group.adminOnly) {
  //         // Only show admin groups if the user is an admin or if we are using the volunteer view
  //         if (isAdmin) {
  //           if (useVolunteerView) {
  //             // If using volunteer view, don't show admin only groups
  //             return false;
  //           }
  //           return true;
  //         }
  //         return false;
  //       }
  //       return true;
  //     })
  //     .map(group => ({
  //       label: group.label,
  //       value: group.types,
  //     }));
  //   console.log('Setting user notification group options:', options, { isAdmin, useVolunteerView });
  //   setUserNotificationGroupOptions(options);
  // }, [notificationGroups, isAdmin]);

  const fetchNextNotifications = useCallback(async () => {
    // console.log('Fetching next notifications with filters:', { type, sort, filters });
    // fetchNotifications({ types: type, sort, filters }, nextCaseToken);
    await fetchNotifications({ types: type, sort, filters });
  }, [type, sort, filters, fetchNotifications]);

  // Create a new array with the notifications and add classes for unread styling
  const gridNotifications = (notifications || []).map(notification => {
    const isRead = !!notification.readAt || false;
    const readClass = isRead ? '' : 'font-bold';

    return {
      ...notification,
      // className: 'font-bold bg-red-100',
      className: readClass,
    };
  });

  // useEffect(() => {
  //   // fetchCases();
  // }, [filters]);

  // const fetchCases = async () => {
  //   setCasesLoading(true);

  //   try {
  //     let nextTokenToUse = nextCaseToken;
  //     let oldCases = nextTokenToUse ? [...cases] : [];

  //     if (
  //       !filtersOnLastSearch ||
  //       filtersOnLastSearch.status !== filters.status ||
  //       filtersOnLastSearch.searchTerm !== filters.searchTerm ||
  //       sortOnLastSearch.fieldName !== sort.fieldName ||
  //       sortOnLastSearch.direction !== sort.direction
  //     ) {
  //       setNextCaseToken(null);

  //       nextTokenToUse = null;
  //       oldCases = [];
  //     }

  //     setSortOnLastSearch(sort);
  //     setFiltersOnLastSearch(filters);

  //     const params = {
  //       status: filters.status,
  //       assignedTo: filters.assignedTo,
  //       searchTerm: filters.searchTerm,
  //       nextToken: nextTokenToUse,
  //       sortField: sort.fieldName ? snakeCase(sort.fieldName).toUpperCase() : '',
  //       sortOrder: sort.direction,
  //       limit: 100,
  //     };
  //     const response = await API.graphql(graphqlOperation(listOwnedCases.replace('assignedToName\n', ''), params));

  //     const result = response.data.listOwnedCases;

  //     setNextCaseToken(result.nextToken);
  //     setCases([...oldCases, ...result.items]);
  //   } catch (error) {
  //     console.error('Error Loading cases: ', error);

  //     setAlert({
  //       type: 'SET_NOTIFICATION',
  //       payload: {
  //         occurs: true,
  //         message: 'Error loading active cases',
  //         textColor: 'redText',
  //         borderColor: 'redBorder',
  //       },
  //     });
  //   }

  //   setCasesLoading(false);
  // };

  // const deleteRecord = async id => {
  //   try {
  //     setDeleting(true);

  //     const updatedCases = [...cases];

  //     const indexOfRecord = updatedCases.findIndex(x => x.id === id);
  //     // Volunteers can't access assignedToName so we need to remove it
  //     const isAdmin = false;
  //     const query = isAdmin ? deleteCase : deleteCase.replace('assignedToName\n', '');
  //     await API.graphql(graphqlOperation(query, { id }));

  //     updatedCases.splice(indexOfRecord, 1);

  //     setCases(updatedCases);
  //   } catch (error) {
  //     console.error('Error deleting record: ', error);

  //     setAlert({
  //       type: 'SET_NOTIFICATION',
  //       payload: {
  //         occurs: true,
  //         message: 'There was an error removing the case',
  //         textColor: 'redText',
  //         borderColor: 'redBorder',
  //       },
  //     });
  //   }

  //   setRecordToDelete(null);
  //   setDeleting(false);
  // };

  // const renderDelete = record => {
  //   if (record.status !== CaseStatus.Active && record.status !== CaseStatus.Returned) {
  //     return null;
  //   }

  //   return (
  //     <div className="flex flex-row items-center justify-between w-full focus:outline-none lg:w-auto ">
  //       <span className="font-semibold lg:hidden">Delete Case:</span>

  //       <button type="button" onClick={() => setRecordToDelete(record)} className="focus:outline-none">
  //         <img src={Trash} alt="Trash" className="object-contain w-5" />
  //       </button>
  //     </div>
  //   );
  // };

  // const renderStatus = ({ status: recordStatus }) => <StatusPill status={recordStatus} />;

  // const renderPoints = ({ totalPoints }) => (
  //   <div
  //     className={`${getAwardColor(
  //       totalPoints
  //     )} h-6 w-8 rounded-full flex font-bold justify-center items-center p-0 mr-4`}>
  //     {totalPoints?.pointsAwarded || ''}
  //   </div>
  // );

  // const getAwardColor = totalPoints => {
  //   // if points aren't awared yet don't show
  //   if (!totalPoints) {
  //     return 'bg-white text-white';
  //   }

  //   if (!totalPoints.isFullPoints) {
  //     return 'bg-pursuit-amber text-white';
  //   }

  //   return 'bg-green-500 text-white';
  // };

  /** Click handler for hyperlinks in notifications
   * Intercepts a click and uses the history router to navigate
   * @param {Object} e - The click event
   * @returns {void}
   */
  const notificationClickHandler = notification => async e => {
    // Prevent the default link behavior
    e.preventDefault();
    // Get the link from the notification
    const link = e.target.getAttribute('href');
    // If the link exists, navigate to it
    // console.log('Notification link clicked:', link, e.target);
    if (!notification.readAt) {
      await markAsRead(notification.id);
    }
    if (link) {
      // Use the history router to navigate
      history.push(link);
    }
  };

  // const getCreatedDate = item => (item.createdAt ? DateTime.fromISO(item.createdAt).toLocaleString() : '-');
  const renderContent = notification => {
    const content = parseMarkdown(notification.message);
    return (
      <span
        className=""
        onClick={notificationClickHandler(notification)}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  };

  // const renderCreatedAt = notification => {
  //   return (
  //     <span className="text-pursuit-gray">
  //       <p className="w-full mt-auto text-right text-gray-300">{getNotificationTime(notification.createdAt)}</p>
  //     </span>
  //   );
  // };

  const renderReadState = notification => {
    return (
      <span className="text-pursuit-red">
        <p
          className="w-full mt-auto text-right text-gray-300 cursor-pointer"
          onClick={async e => {
            e.stopPropagation();
            if (!!notification.readAt) {
              markAsUnread(notification.id);
              // await markUnread();
              // console.log('Notification marked as unread:', update);
              // setNotification(update);
            } else {
              markAsRead(notification.id);
            }

            // unRead();
          }}>
          <NotificationToggle notificationId={notification.id} isRead={notification.readAt} />{' '}
          {notification.readAt ? 'Read on ' + getNotificationTime(notification.readAt) : 'Mark as read'}
          {/* {getNotificationTime(notification.readAt)} */}
        </p>
      </span>
    );
  };

  return (
    <>
      {/* {recordToDelete ? (
        <PopUpConfirmation
          title="Delete Record"
          content={`Are you sure you want to delete ${recordToDelete?.caseNumber || 'this record'}?`}
          onConfirm={() => {
            deleteRecord(recordToDelete.id);
          }}
          onCancel={() => {
            setRecordToDelete(null);
          }}
          confirmLoading={deleting}
          confirmText="DELETE"
          confirmLoadingText="DELETING"
          destructive
          className="w-11/12 lg:w-auto"
        />
      ) : null} */}

      <Container height="lg:h-152" width="lg:mx-8" padding="p-4" margin="m-3 lg:m-auto">
        <div className="flex flex-col pt-4 lg:px-4 notifications">
          <HeaderText className="mb-4 text-2xl text-left lg:text-4xl">My Notifications</HeaderText>
          {/* {JSON.stringify({ userNotificationGroups: userNotificationGroupOptions, isAdmin, useVolunteerView })} */}

          <div className="items-end justify-end mb-10 lg:flex">
            <div className="lg:mr-4">
              <DropDown
                value={userNotificationGroupOptions.find(x => x.value === type)}
                onChange={option => {
                  console.log('Set type filter', option);
                  if (!option) {
                    resetNotifications();
                  }
                  setType(option ? option.value : null);
                }}
                containerClassName="w-72"
                width="w-72"
                label="Notification Type"
                options={userNotificationGroupOptions}
                // loadOptions={userNotificationGroupOptions}

                placeholder="Type"
                isClearable
              />
            </div>
            {isAdmin && !useVolunteerView ? (
              <>
                <div className="flex flex-col">
                  <div className="flex flex-row">
                    <p className="mb-1 font-light light-primary-blue-text">Search Term</p>

                    <ToolTip
                      tooltipText="Find records with the search term in the notification content."
                      title="Search Term"
                      className="ml-2 text-pursuit-gray"
                    />
                  </div>
                  <input
                    type="text"
                    value={search}
                    onChange={event => setSearch(event.target.value)}
                    placeholder="Search Term"
                    className="w-64 h-10 px-4 bg-gray-100 lg:mr-4"
                    onKeyDown={event => {
                      const pressedKey = event.key;

                      if (pressedKey === 'Enter') {
                        setFilters({
                          type,
                          searchTerm: search,
                        });
                      }
                    }}
                  />
                </div>

                <Button
                  solidBlue
                  className="w-24 px-4"
                  onClick={() => {
                    // setNextCaseToken(null);
                    setFilters({
                      type,
                      searchTerm: search,
                    });
                  }}>
                  FILTER
                </Button>
              </>
            ) : null}
          </div>
          {/* {notificationCount} */}
          <DataGrid
            columns={[
              { title: '', fieldName: 'type', renderFunction: getIcon, sortable: false, width: '4rem' },
              { title: 'Title', fieldName: 'title', sortable: true, width: '12rem' },
              {
                title: 'Date',
                fieldName: 'createdAt',
                sortable: true,
                width: '10rem',
                // value: item => DateTime.fromISO(item.createdAt).toLocaleString(DateTime.DATETIME_MED),
                value: item => DateTime.fromISO(item.createdAt).toLocaleString(DateTime.DATE_MED),
                // renderFunction: renderCreatedAt,
              },
              { title: 'Content', fieldName: 'message', sortable: false, renderFunction: renderContent },
              { title: '', fieldName: 'readAt', renderFunction: renderReadState, sortable: false, width: '13rem' },
              // { title: '', renderFunction: renderDelete, width: '2rem', noLink: true },
              // { title: 'Case Number', fieldName: 'caseNumber', sortable: true },
              // { title: 'First Name', fieldName: 'firstName', sortable: false },
              // { title: 'Last Name', fieldName: 'lastName', sortable: false },
              // { title: 'Date Opened', fieldName: 'createdAt', value: getCreatedDate, sortable: true },
              // { title: 'Case Status', fieldName: 'status', renderFunction: renderStatus },
              // { title: 'Points', fieldName: 'totalPoints', renderFunction: renderPoints },
            ]}
            sort={sort}
            setSort={value => {
              resetNotifications();
              setSort(value);
            }}
            loading={loading && !gridNotifications.length}
            // data={notifications}
            data={gridNotifications}
            noRecordsText="You have no notifications"
            // rowLink={item => `/investigation/${item.id}`}
            // loadNextPage={() => {
            //   // return fetchCases(filters);
            //   return fetchNotifications();
            // }}
            loadNextPage={fetchNextNotifications}
            hasMore={hasMore}
            containerHeight="h-88"
            gridKey="user-notifications"
            className="notification-list"
          />
        </div>
      </Container>
    </>
  );
};

export default UserNotifications;
